export default __webpack_public_path__ + "static/media/green-candy.599f7016.png";